export const mapLayoutTypeCodeToName = (code) => {
    switch (code) {
        case 1:
            return 'Landscape';
        case 2:
            return 'Portrait';
        case 3:
            return 'LED';
        case 4:
            return 'Custom';
        default:
            return null;
    }
};

export const mapLayoutTypeNameToCode = (name) => {
    switch (name) {
        case 'Landscape':
            return 1;
        case 'Portrait':
            return 2;
        case 'LED':
            return 3;
        case 'Custom':
        default:
            return 4;
    }
};

export const normalizeLayoutType = (item) => {
    if (item?.layoutType && typeof item.layoutType === 'string') {
        return item.layoutType;
    }
    if (typeof item?.layout_type === 'number') {
        return mapLayoutTypeCodeToName(item.layout_type) || 'Custom';
    }
    if (typeof item?.layout_type === 'string' && item.layout_type.trim()) {
        return item.layout_type;
    }
    return 'Custom';
};
